import { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import CustomToolbar from "./CustomToolbar";
import { Text } from "@mantine/core";
import { useDebouncedValue } from "@mantine/hooks";
import TinyMCEEditor from "../Tinymce/TinyMCEEditor";

const QuillEditor = ({
  onChangeValue,
  setValue,
  toolbarId,
  label,
  description,
  addImageToArticle,
}: QuillEditorType) => {
  // console.log("description", description);
  const [text, setText] = useState(description || ""); // Khởi tạo với giá trị description
  const [editorHtml, setEditorHtml] = useState(description || ""); // Khởi tạo với giá trị description
  const [debouncedHtml] = useDebouncedValue(editorHtml, 300); // Đợi 300ms sau khi người dùng ngừng nhập
  const [wordCount, setWordCount] = useState(0);
  const countWords = (html: string): number => {
    // Loại bỏ các thẻ HTML và khoảng trắng thừa
    const text = html.replace(/<[^>]+>/g, "").trim();
    // Tách chuỗi thành các từ bằng regex và đếm số lượng từ
    const words = text.match(/\b\w+\b/g) || [];
    return words.length;
  };

  // const handleChange = (html: any) => {
  //   setEditorHtml(html);
  //   setText(html);
  //   if (onChangeValue) {
  //     onChangeValue(html);
  //   }
  //   setValue(html);
  // };
  // const modules = {
  //   toolbar: {
  //     container: "#" + toolbarId,
  //   },
  // };
  // const formats = [
  //   "font",
  //   "size",
  //   "bold",
  //   "italic",
  //   "underline",
  //   "strike",
  //   "color",
  //   "background",
  //   "script",
  //   "header",
  //   "blockquote",
  //   "code-block",
  //   "indent",
  //   "list",
  //   "direction",
  //   "align",
  //   "link",
  //   "image",
  //   "video",
  //   "formula",
  // ];

  // Cập nhật text và word count khi description thay đổi
  useEffect(() => {
    if (description) {
      setText(description);
      setEditorHtml(description);
      setWordCount(countWords(description)); // Đếm số từ ngay khi description được thiết lập
    }
  }, [description]);

  // Cập nhật word count khi debouncedHtml thay đổi
  useEffect(() => {
    setWordCount(countWords(debouncedHtml));
  }, [debouncedHtml]);
  return (
    <>
      <Text fw={500}>{label}</Text>
      {/* <CustomToolbar id={toolbarId} /> */}
      {/* <ReactQuill
        value={text}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        style={{ width: "100%", height: "450px" }}
      /> */}
      <TinyMCEEditor
        height="450"
        contentText={description || ""}
        nameOnchange={"description"}
        setValue={(val: string) => {
          setText(val);
          setEditorHtml(val);
          // onChangeValue(val);
          setValue(val);
        }}
        addImageToArticle={addImageToArticle ? addImageToArticle : undefined}
      />
      <Text fw={500} style={{ marginTop: 10 }}>
        Số kí tự: {wordCount} từ
      </Text>
    </>
  );
};

type QuillEditorType = {
  onChangeValue?: (html: string) => void;
  setValue: (value: any) => void;
  toolbarId: string;
  label?: string;
  description?: string | null;
  addImageToArticle?: string;
};

export default QuillEditor;
